<template>
  <div class="rotate-handler"></div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
.rotate-handler {
  position: absolute;
  width: 26px;
  height: 26px;
  top: -36px;
  margin-left: -13px;
  border: none;
  background: transparent;
  border-radius: 0;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  font-size: 24px;
  line-height: 1;

  &:active {
    cursor: grabbing;
  }

  &::before {
    content: '↻';
    font-weight: 900;
  }
}
</style>